import { useState } from "react";
import MainDashboardFilters from "../dashboardfilters/maindashboardfilters";
import MainSearch from "../dashboardfilters/mainsearch";
import MainTable from "../tables/maintable";
import SuperAdminTable from "../tables/superadmintable";
import SupervisorDashboardFilters from "../dashboardfilters/superadmindashboardfilters";
import SuperVisorSearch from "../dashboardfilters/supervisorsearch";
import SuperVisorTable from "../tables/weektable";

const SuperAdminDashboard = () => {
  const [isModal, setIsModal] = useState(false);
  const [filterby, setFilterBy] = useState("No Grouping");

  return (
    <div className="sm:pt-7 sm:px-8">
      <SupervisorDashboardFilters filterby={filterby} setFilterBy={setFilterBy} />
    
      {filterby === "Company" ? (<>
   <div className="flex flex-col items-start gap-1 self-stretch p-6 rounded-lg border border-gray-300 bg-white shadow-sm mb-4">
   <h2 className="text-xl font-semibold text-gray-900">Michael Adreson</h2>
   <p className="text-sm text-gray-600">Extricxal Superdent</p>
 </div>

   <SuperVisorTable/>
   <div className="mb-8 mt-4">
   <button 
      
         
                            className={`min-w-[180px] px-4 py-2 rounded-md transition-colors duration-200 ${
                     
                                    'bg-[#900] text-white' 
                                    
                            }`}
                        >
                           Recap
                        </button>

 </div>

 </>
      ) : (<>
        <SuperVisorSearch />
        <div className="p-4 text-gray-600 font-normal text-sm text-start leading-5">
          Last edited by: John Doe
        </div>
         <SuperAdminTable filterby={filterby} />
        </>
      )}
     
  

      
    </div>
  );
};

export default SuperAdminDashboard;